<template>
  <div v-if="false">
    <div class="list_null bg-white" v-if="false">
      <div class="item">
        <img src="@/assets/images/billRenew@3x.png" class="image" />
        <div>綁定帳單</div>
        <div>每日更新</div>
      </div>
      <div class="item">
        <img src="@/assets/images/billNotice@3x.png" class="image" />
        <div>新帳單</div>
        <div>推播</div>
      </div>
      <div class="item">
        <img src="@/assets/images/billPayall@3x.png" class="image" />
        <div>一次</div>
        <div>全部繳清</div>
      </div>
    </div>
    <div :class="isListInModify ? 'padding bg-white' : 'padding'" v-if="isListInModify">
      <div class="text-gray1" style="font-size: 14px">適用項目</div>
      <div style="margin: 10px 0">
        <span class="text-gray2 border-text">台北市路邊臨時停車費</span>
      </div>
      <ul class="text-gray2 description">
        <li>悠遊付將於每日凌晨 2:00~4:00 更新帳單資訊，非即時更新，故實際帳單以查詢結果為準。</li>
        <li>其他需要提醒的事項。</li>
      </ul>
    </div>
    <div class="padding bg-white" v-if="isListInModify">
      <button class="btn btn-primary" @click="showListDialog">新增綁定項目</button>
    </div>

    <payment-binding-list :paymentList="paymentList" :modify="isListInModify"></payment-binding-list>

    <payment-list-is-null v-if="paymentList == null"></payment-list-is-null>

    <payment-list-select-dialog :is-show="isShowListDialog" @closeListDialog="closeListDialog"></payment-list-select-dialog>
  </div>
</template>

<script>
import PaymentListSelectDialog from '../components/PayMentListSelectDialog';
import PaymentBindingList from '../components/PaymentBindingList';
import PaymentListIsNull from '../components/PaymentListIsNull';
import { queryBillList, queryBindBillList, getUserConfig } from '../api/api';
import { mapActions } from 'vuex';

export default {
  name: 'payment-list',
  components: { PaymentListIsNull, PaymentBindingList, PaymentListSelectDialog },
  data() {
    return {
      isShowListDialog: false,
      isListInModify: false,
      bindingList: [],
      paymentList: {
        parking: [
          {
            id: '',
            type: '',
            price: 0,
            children: [
              {
                id: '',
                date: '',
                period: '',
                price: 0,
              }
            ],
          },
        ],
      },
      more: [],
    };
  },
  mounted() {
    this.checkBillNotify();
  },
  methods: {
    ...mapActions(['setReadyToPayBill', 'sentApp']),
    checkBillNotify() {
      let billHash = this.$route.query.bill_hash;
      if (billHash !== undefined && billHash !== null) {
        queryBindBillList({bill_hash: billHash}).then((res) => {
          if (res.error === undefined || res.error === null) {
            this.setReadyToPayBill(res);
            this.$router.replace({ 
            path: '/goPay',
            query: {
                payment_item_id: res.payment_item_id,
                payment_query_type: 'REALTIME-1',
                parameter1: res.parameter1,
                parameter2: res.parameter2,
                parameter3: res.parameter3,
                parameter4: res.parameter4,
              },
            });
          } else {
            alert(res.error.message);
            this.sentApp({
            action: 'finish',
            payload: {},
           });
          }
        });
      }
    },
    showListDialog() {
      this.isShowListDialog = true;
    },
    closeListDialog() {
      this.isShowListDialog = false;
    },
  },
};
</script>

<style scoped>
.border-text {
  background: rgba(64, 64, 64, 0.05);
  border-radius: 16pt;
  padding: 5px 12px;
  margin: 5px;
}

.dark-card .flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9pt 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.field {
  margin: 10px 0;
}
</style>
